import { render, staticRenderFns } from "./myAdviceForm.vue?vue&type=template&id=475186eb&scoped=true"
import script from "./myAdviceForm.vue?vue&type=script&lang=js"
export * from "./myAdviceForm.vue?vue&type=script&lang=js"
import style0 from "./myAdviceForm.vue?vue&type=style&index=0&id=475186eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475186eb",
  null
  
)

export default component.exports